import { gql } from "@apollo/client";

export const UPLOAD_IMAGE = gql`
  mutation UploadImage($input: ImageInput!) {
    uploadImage(input: $input) {
       success
       message
       fileUrl {
        s3_url
        fileUrl
       }
    }
  }
`;